import { render } from "./VabeneReviewPage.vue?vue&type=template&id=4e0e256a&ts=true"
import script from "./VabeneReviewPage.vue?vue&type=script&lang=ts"
export * from "./VabeneReviewPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__